import styled from "styled-components";

export const Container = styled.div`
  margin: 20px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${(props) => (props.hasError ? `0px` : "20px")};
  width: inherit;

  label {
    width: 25%;
    font-size: 1rem;
  }

  input {
    width: 80% !important;
  }

  @media (max-width: 760px) {
    flex-direction: column;
    align-items: flex-start;

    input {
      width: 100% !important;
      font-size: 1.1rem;
    }
  }
`;

export const ErrorMessage = styled.p`
  font-size: 1rem;
  /* font-weight: bold; */
  color: red;
  text-align: left;
  margin: 0 0 20px 25%;

  @media (max-width: 760px) {
    margin-left: 0;
  }
`;

export const Form = styled.form`
  width: inherit;
  display: flex;
  flex-direction: column;
`;
